<template>
  <div>
    <HotelGallery v-if="getMerchant().merchant_type == 'hotel'"></HotelGallery>
    <TicketGallery v-else-if="getMerchant().merchant_type == 'ticket' && getMerchant().is_special_merchant"></TicketGallery>
    <GeneralGallery v-else></GeneralGallery>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import GeneralGallery from "@/pages/general/GeneralGallery";
  import HotelGallery from "@/pages/hotel/Gallery";
  import TicketGallery from "@/pages/ticket/TicketGallery";
  

export default {
  components: {
    HotelGallery,
    GeneralGallery,
    TicketGallery
  },
  metaInfo(){
    return {
      title: 'Gallery',
      titleTemplate: this.getMetaTitleTemplate()
    }
  },
  methods: {
    ...mapGetters(["getMerchant",'getMetaTitleTemplate']),
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/general/Gallery.vue